import { SingleAutocomplete } from 'react-scale/corp/components/Autocomplete/SingleAutocomplete';
import { IAudience } from '@scale/shared/types/audience';
import apiFetch from 'react-scale/lib/api-fetch';
import { SelectMenu } from '@scale/scaleui';

interface ISelectAudienceProps {
  audience: (IAudience & { id: string }) | null;
  setAudience?: (audience: (IAudience & { id: string }) | null) => void;
  audienceBucket: number | null;
  setAudienceBucket?: (index: number | null) => void;
}

export const SelectAudience: React.FC<ISelectAudienceProps> = ({
  audience,
  setAudience,
  audienceBucket,
  setAudienceBucket,
}) => {
  return (
    <div className="scale-ui flex items-end gap-2">
      <SingleAutocomplete
        selectedOption={audience ?? undefined}
        disabled={!(setAudience && setAudienceBucket)}
        searchFunction={async searchValue => {
          const query = {
            search: searchValue,
          };
          const results = await apiFetch<{
            items: IAudience[];
            itemCount: number;
            page: number;
            pageSize: number;
          }>(null, 'corp-api/audiences', {
            query,
          });
          return results.items.map(a => ({
            ...a,
            id: a._id,
          }));
        }}
        onChange={a => {
          if (setAudience && setAudienceBucket) {
            if (a) {
              setAudience(a);
              setAudienceBucket(0);
            } else {
              setAudience(null);
              setAudienceBucket(null);
            }
          }
        }}
        placeholder="Audiences"
      />
      {audience && (
        <SelectMenu
          label="Selected Bucket"
          disabled={!(setAudience && setAudienceBucket)}
          options={audience.buckets.map((bucket, bucketIndex) => ({
            name: `Bucket ${bucketIndex + 1} (${bucket.percentage}%)`,
            id: `${bucketIndex}`,
          }))}
          multiple={false}
          selectedOptionId={audienceBucket ? `${audience.buckets[audienceBucket]}` : `0`}
          setSelected={(bucketId: string | undefined) => {
            if (setAudienceBucket) {
              if (bucketId) {
                const bucketIndex = +bucketId;
                setAudienceBucket(bucketIndex);
              } else {
                setAudienceBucket(null);
              }
            }
          }}
        />
      )}
    </div>
  );
};
